import React, { useState } from 'react';
import {
    Table, Card, Button, Space, Typography, Form, Input, Select,
    Tag, Drawer, Descriptions, Divider, Modal, message, Tabs, Alert, Empty
} from 'antd';
import {
    SearchOutlined, ReloadOutlined, FileTextOutlined, CopyOutlined,
    DownloadOutlined, CheckCircleOutlined
} from '@ant-design/icons';

const { Text, Title } = Typography;

// ══════════════════════════════════════════════
//  广告抽佣账单（平台账务 → 广告抽佣账单）
//  账单粒度：企业 + 广告源 + 账单周期
//  明细粒度：App版本 + 广告平台 + 广告源 + 币种
//  复用出账日与「待确认 / 已确认」确认流程，独立账单编号
// ══════════════════════════════════════════════

// ── Enums ──
const adSourceLabel = { 1: '企业广告源', 2: '平台广告源' };
const adSourceColor = { 1: 'orange', 2: 'red' };
const accountLabel = { 1: '消费账户', 2: '收益账户' };
const accountColor = { 1: 'blue', 2: 'green' };
const settleTypeLabel = { 1: '平台扣款', 2: '企业收入' };
const settleTypeColor = { 1: 'red', 2: 'green' };
const statusLabel = { 2: '待确认', 3: '已确认' };
const statusColor = { 2: '#e6a23c', 3: '#67c23a' };

// TODO: 联调时替换为接口数据
const mockBilled = [
    {
        id: 1, serialNumber: 'ADBILL202608-001',
        companyName: '东莞康林物联网有限公司', companyId: 'JGSf0Nd7',
        adSource: 1, date: '2026-08',
        revenueCny: 186000, revenueUsd: 0,
        commissionCny: 27900, commissionUsd: 0,
        settleCny: 27900, settleUsd: 0,
        status: 2,
        billTime: '2026-09-05 00:00:00',
        details: [
            { key: 'd1', appInfo: 'HomeStar (iOS-国内)', adPlatform: 'max', adSource: 1, revenueCny: 96000, revenueUsd: 0, rate: 15.00, commissionCny: 14400, commissionUsd: 0 },
            { key: 'd2', appInfo: 'HomeStar (Android-国内)', adPlatform: 'taku', adSource: 1, revenueCny: 90000, revenueUsd: 0, rate: 15.00, commissionCny: 13500, commissionUsd: 0 },
        ],
    },
    {
        id: 2, serialNumber: 'ADBILL202608-002',
        companyName: '东莞康林物联网有限公司', companyId: 'JGSf0Nd7',
        adSource: 2, date: '2026-08',
        revenueCny: 0, revenueUsd: 32000,
        commissionCny: 5600, commissionUsd: 800,
        settleCny: 0, settleUsd: 24000,
        status: 3, ackBillTime: '2026-09-06 10:30:00',
        billTime: '2026-09-05 00:00:00',
        details: [
            { key: 'd1', appInfo: 'ParkingCloud (iOS-海外)', adPlatform: 'fengchuan', adSource: 2, revenueCny: 0, revenueUsd: 20000, rate: 2.50, commissionCny: 3500, commissionUsd: 500 },
            { key: 'd2', appInfo: 'ParkingCloud (Android-全球)', adPlatform: 'AdMob', adSource: 2, revenueCny: 0, revenueUsd: 12000, rate: 2.50, commissionCny: 2100, commissionUsd: 300 },
        ],
    },
    {
        id: 3, serialNumber: 'ADBILL202608-003',
        companyName: '南京鹤梦信息技术有限公司', companyId: 'HM-8827-X',
        adSource: 2, date: '2026-08',
        revenueCny: 0, revenueUsd: 9800,
        commissionCny: 0, commissionUsd: 0,
        settleCny: 0, settleUsd: 9800,
        status: 2,
        billTime: '2026-09-05 00:00:00',
        details: [
            { key: 'd1', appInfo: 'HM IoT App (iOS-海外)', adPlatform: 'max', adSource: 2, revenueCny: 0, revenueUsd: 9800, rate: null, commissionCny: 0, commissionUsd: 0 },
        ],
    },
    {
        id: 4, serialNumber: 'ADBILL202608-004',
        companyName: '捷顺科技股份有限公司', companyId: 'A619355x',
        adSource: 1, date: '2026-08',
        revenueCny: 74000, revenueUsd: 0,
        commissionCny: 7400, commissionUsd: 0,
        settleCny: 7400, settleUsd: 0,
        status: 3, ackBillTime: '2026-09-05 16:00:00',
        billTime: '2026-09-05 00:00:00',
        details: [
            { key: 'd1', appInfo: 'ParkingCloud (iOS-国内)', adPlatform: 'fengchuan', adSource: 1, revenueCny: 74000, revenueUsd: 0, rate: 10.00, commissionCny: 7400, commissionUsd: 0 },
        ],
    },
];

const mockUnbilled = [
    {
        id: 5,
        companyName: '捷顺科技股份有限公司', companyId: 'A619355x',
        adSource: 1, date: '2026-08',
        revenueCny: 22000, revenueUsd: 0, commissionCny: 2200, commissionUsd: 0,
        details: [
            { key: 'd1', appInfo: 'SmartHome Pro (Android-国内)', adPlatform: 'taku', adSource: 1, revenueCny: 22000, revenueUsd: 0, rate: 10.00, commissionCny: 2200, commissionUsd: 0 },
        ],
    },
];

const fmtYuan = (val) => (Number(val) / 100).toFixed(2);

const renderDualAmount = (cny, usd, mainStyle = {}, subStyle = {}) => (
    <div>
        <div style={{ fontWeight: 600, ...mainStyle }}>¥ {fmtYuan(cny)}</div>
        <div style={{ fontSize: 12, color: '#999', ...subStyle }}>$ {fmtYuan(usd)}</div>
    </div>
);

const AdCommissionBill = () => {
    const [activeTab, setActiveTab] = useState('billed');
    const [billedData] = useState(mockBilled);
    const [unbilledData] = useState(mockUnbilled);

    // 出账日（与订单抽佣账单共用）
    const [billDay, setBillDay] = useState(5);
    const [billDayEditVisible, setBillDayEditVisible] = useState(false);
    const [billDayEditVal, setBillDayEditVal] = useState(5);

    // 详情抽屉
    const [detailVisible, setDetailVisible] = useState(false);
    const [currentBillId, setCurrentBillId] = useState(null);

    // 确认出账
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [confirmRow, setConfirmRow] = useState(null);
    const [confirmAction, setConfirmAction] = useState(1); // 1=确认出账, 2=重新出账
    const [confirmReason, setConfirmReason] = useState('');

    // 操作记录
    const [logsVisible, setLogsVisible] = useState(false);
    const [logsRow, setLogsRow] = useState(null);

    const getCurrentDetail = () => [...billedData, ...unbilledData].find((d) => d.id === currentBillId) || null;

    const billedColumns = [
        {
            title: '账单编号', dataIndex: 'serialNumber', key: 'serialNumber', width: 180,
            render: (text) => (
                <span>
                    <Text style={{ fontFamily: 'monospace', fontSize: 13 }}>{text}</Text>
                    <Button type="link" size="small" icon={<CopyOutlined />} style={{ padding: 0, marginLeft: 4 }}
                        onClick={() => { navigator.clipboard.writeText(text); message.success('已复制'); }} />
                </span>
            ),
        },
        {
            title: '企业信息', key: 'enterprise', width: 200,
            render: (_, r) => (
                <div>
                    <div style={{ fontWeight: 500, color: '#262626' }}>{r.companyName}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>ID: {r.companyId}</Text>
                </div>
            ),
        },
        {
            title: '广告源', dataIndex: 'adSource', key: 'adSource', width: 120,
            render: (v) => <Tag color={adSourceColor[v]}>{adSourceLabel[v] || '-'}</Tag>,
        },
        { title: '账单周期', dataIndex: 'date', key: 'date', width: 100 },
        {
            title: '广告收益', key: 'revenue', width: 150, align: 'right',
            render: (_, r) => renderDualAmount(r.revenueCny, r.revenueUsd),
        },
        {
            title: '抽佣总额', key: 'commission', width: 150, align: 'right',
            render: (_, r) => renderDualAmount(r.commissionCny, r.commissionUsd, { color: '#e6a23c' }, { color: '#e6a23c' }),
        },
        {
            title: '结算账户', key: 'account', width: 120, align: 'center',
            render: (_, r) => <Tag color={accountColor[r.adSource]}>{accountLabel[r.adSource] || '-'}</Tag>,
        },
        {
            title: '结算金额', key: 'settle', width: 160, align: 'right',
            render: (_, r) => (
                <div>
                    <Tag color={settleTypeColor[r.adSource]} style={{ marginBottom: 4, fontSize: 11 }}>
                        {settleTypeLabel[r.adSource] || '-'}
                    </Tag>
                    {renderDualAmount(r.settleCny, r.settleUsd, { fontSize: 15, color: r.adSource === 1 ? '#f50' : '#52c41a' })}
                </div>
            ),
        },
        {
            title: '状态', dataIndex: 'status', key: 'status', width: 90,
            render: (s) => <span style={{ color: statusColor[s] }}>● {statusLabel[s] || '-'}</span>,
        },
        {
            title: '操作', key: 'action', width: 150, fixed: 'right',
            render: (_, record) => (
                <Space size={0} split={<Divider type="vertical" style={{ margin: '0 4px' }} />}>
                    {record.status === 2 && (
                        <Button type="link" size="small" onClick={() => { setConfirmRow(record); setConfirmAction(1); setConfirmReason(''); setConfirmVisible(true); }}>立即确认</Button>
                    )}
                    {record.status === 3 && (
                        <Button type="link" size="small" onClick={() => { setLogsRow(record); setLogsVisible(true); }}>操作记录</Button>
                    )}
                    <Button type="link" size="small" onClick={() => { setCurrentBillId(record.id); setDetailVisible(true); }}>详情</Button>
                </Space>
            ),
        },
    ];

    const unbilledColumns = [
        {
            title: '企业信息', key: 'enterprise', width: 220,
            render: (_, r) => (
                <div>
                    <div style={{ fontWeight: 500, color: '#262626' }}>{r.companyName}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>ID: {r.companyId}</Text>
                </div>
            ),
        },
        {
            title: '广告源', dataIndex: 'adSource', key: 'adSource', width: 120,
            render: (v) => <Tag color={adSourceColor[v]}>{adSourceLabel[v] || '-'}</Tag>,
        },
        { title: '账单周期', dataIndex: 'date', key: 'date', width: 100 },
        {
            title: '广告收益（预估）', key: 'revenue', width: 160, align: 'right',
            render: (_, r) => renderDualAmount(r.revenueCny, r.revenueUsd),
        },
        {
            title: '抽佣金额（预估）', key: 'commission', width: 160, align: 'right',
            render: (_, r) => renderDualAmount(r.commissionCny, r.commissionUsd, { color: '#e6a23c' }, { color: '#e6a23c' }),
        },
        {
            title: '操作', key: 'action', width: 80, fixed: 'right',
            render: (_, record) => (
                <Button type="link" size="small" onClick={() => { setCurrentBillId(record.id); setDetailVisible(true); }}>详情</Button>
            ),
        },
    ];

    const detailColumns = [
        { title: '应用（App-系统-区域）', dataIndex: 'appInfo', key: 'appInfo', width: 220 },
        {
            title: '广告平台', dataIndex: 'adPlatform', key: 'adPlatform', width: 130,
            render: (t) => <Tag color="geekblue" style={{ border: 'none' }}>{t}</Tag>,
        },
        {
            title: '广告源', dataIndex: 'adSource', key: 'adSource', width: 110,
            render: (v) => <Tag color={adSourceColor[v]}>{adSourceLabel[v] || '-'}</Tag>,
        },
        {
            title: '广告收益', key: 'revenue', width: 150, align: 'right',
            render: (_, r) => renderDualAmount(r.revenueCny, r.revenueUsd),
        },
        {
            title: '抽佣比例', key: 'rate', width: 100, align: 'right',
            render: (_, r) => (r.rate == null
                ? <Text type="secondary">不抽佣</Text>
                : <Text style={{ color: '#409eff', fontWeight: 600 }}>{r.rate.toFixed(2)}%</Text>),
        },
        {
            title: '抽佣金额', key: 'commission', width: 140, align: 'right',
            render: (_, r) => renderDualAmount(r.commissionCny, r.commissionUsd, { color: '#e6a23c' }, { color: '#e6a23c' }),
        },
    ];

    // ── 操作记录：抽佣比例汇总（按广告平台列出） ──
    const commissionRateText = (record) => {
        const list = (record.details || []).map((d) => `${d.adPlatform} ${d.rate == null ? '不抽佣' : `${d.rate.toFixed(2)}%`}`);
        return list.length ? list.join('、') : '—';
    };

    const renderSystemBillStep = (record) => (
        <Descriptions bordered column={2} size="small" style={{ background: '#fafafa', borderRadius: 6 }}>
            <Descriptions.Item label="账单编号">{record.serialNumber}</Descriptions.Item>
            <Descriptions.Item label="账单周期">{record.date}</Descriptions.Item>
            <Descriptions.Item label="广告源"><Tag color={adSourceColor[record.adSource]}>{adSourceLabel[record.adSource]}</Tag></Descriptions.Item>
            <Descriptions.Item label="抽佣比例">{commissionRateText(record)}</Descriptions.Item>
            <Descriptions.Item label="广告收益">¥ {fmtYuan(record.revenueCny)} / $ {fmtYuan(record.revenueUsd)}</Descriptions.Item>
            <Descriptions.Item label="抽佣总额">¥ {fmtYuan(record.commissionCny)} / $ {fmtYuan(record.commissionUsd)}</Descriptions.Item>
            <Descriptions.Item label="结算金额" span={2}>¥ {fmtYuan(record.settleCny)} / $ {fmtYuan(record.settleUsd)}</Descriptions.Item>
        </Descriptions>
    );

    const renderRebillStep = (record) => (
        <div>
            <Alert message={record.rebillReason || '重新出账原因：抽佣比例与最新商务协议不符，需重新出账'} type="warning" showIcon style={{ marginBottom: 12, fontSize: 13 }} />
            <Descriptions bordered column={2} size="small" style={{ background: '#fafafa', borderRadius: 6 }}>
                <Descriptions.Item label="操作人">{record.operateUser || 'admin'}</Descriptions.Item>
                <Descriptions.Item label="新账单编号">{record.serialNumber}</Descriptions.Item>
                <Descriptions.Item label="系统重新出账时间">{record.rebillTime || record.billTime || '—'}</Descriptions.Item>
                <Descriptions.Item label="抽佣比例">{commissionRateText(record)}</Descriptions.Item>
                <Descriptions.Item label="广告收益">¥ {fmtYuan(record.revenueCny)} / $ {fmtYuan(record.revenueUsd)}</Descriptions.Item>
                <Descriptions.Item label="抽佣总额">¥ {fmtYuan(record.commissionCny)} / $ {fmtYuan(record.commissionUsd)}</Descriptions.Item>
                <Descriptions.Item label="结算金额" span={2}>¥ {fmtYuan(record.settleCny)} / $ {fmtYuan(record.settleUsd)}</Descriptions.Item>
            </Descriptions>
        </div>
    );

    const renderManualConfirmStep = (record) => (
        <Descriptions bordered column={2} size="small" style={{ background: '#fafafa', borderRadius: 6 }}>
            <Descriptions.Item label="账单编号">{record.serialNumber}</Descriptions.Item>
            <Descriptions.Item label="账单周期">{record.date}</Descriptions.Item>
            <Descriptions.Item label="抽佣比例">{commissionRateText(record)}</Descriptions.Item>
            <Descriptions.Item label="广告收益">¥ {fmtYuan(record.revenueCny)} / $ {fmtYuan(record.revenueUsd)}</Descriptions.Item>
            <Descriptions.Item label="抽佣总额"><Text style={{ color: '#e6a23c', fontWeight: 600 }}>¥ {fmtYuan(record.commissionCny)} / $ {fmtYuan(record.commissionUsd)}</Text></Descriptions.Item>
            <Descriptions.Item label="结算金额"><Text style={{ color: '#e6a23c', fontWeight: 600 }}>¥ {fmtYuan(record.settleCny)} / $ {fmtYuan(record.settleUsd)}</Text></Descriptions.Item>
            <Descriptions.Item label="操作人" span={2}>{record.operateUser || 'admin'}</Descriptions.Item>
        </Descriptions>
    );

    const logSteps = (record) => [
        { color: '#409eff', title: '系统出账', time: record.billTime, render: () => renderSystemBillStep(record) },
        {
            color: '#f56c6c',
            title: '重新出账',
            time: '2026-09-07 09:15:00',
            render: () => renderRebillStep({ ...record, rebillTime: '2026-09-07 09:20:00', operateUser: 'admin', rebillReason: '抽佣比例与最新商务协议不符，需重新出账' }),
        },
        { color: '#67c23a', title: '人工审核 - 确认出账', time: record.ackBillTime || record.billTime, render: () => renderManualConfirmStep({ ...record, operateUser: 'admin' }) },
    ];

    const detail = getCurrentDetail();

    const renderSummaryCards = (d) => {
        if (!d) return null;
        const cards = [
            {
                label: '广告收益',
                value: <div><div>¥ {fmtYuan(d.revenueCny)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtYuan(d.revenueUsd)}</div></div>,
                bg: '#f5f7fa', color: '#303133',
            },
            {
                label: '抽佣总额',
                value: <div><div>¥ {fmtYuan(d.commissionCny)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtYuan(d.commissionUsd)}</div></div>,
                bg: '#fdf6ec', color: '#e6a23c',
            },
            {
                label: d.adSource === 1 ? '平台扣款金额' : '企业结算金额',
                value: <div><div>¥ {fmtYuan(d.settleCny)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtYuan(d.settleUsd)}</div></div>,
                bg: '#fef0f0', color: d.adSource === 1 ? '#f56c6c' : '#67c23a',
            },
        ];
        return (
            <div style={{ display: 'flex', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
                {cards.map((c, i) => (
                    <div key={i} style={{ flex: '1 1 0', minWidth: 140, padding: '16px 12px', borderRadius: 6, background: c.bg, textAlign: 'center' }}>
                        <div style={{ fontSize: 13, color: '#909399', marginBottom: 8 }}>{c.label}</div>
                        <div style={{ fontSize: 18, fontWeight: 600, color: c.color }}>{c.value}</div>
                    </div>
                ))}
            </div>
        );
    };

    const handleConfirmSubmit = () => {
        if (confirmAction === 2 && !confirmReason.trim()) {
            message.warning('请输入重新出账原因');
            return;
        }
        message.success(confirmAction === 1 ? '确认出账成功' : '重新出账已发起');
        setConfirmVisible(false);
    };

    return (
        <div style={{ padding: 24 }}>
            {/* 抽佣出账日 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 20px', background: '#fff', borderRadius: 8, border: '1px solid #e4e7ed', marginBottom: 16 }}>
                <Text strong style={{ fontSize: 14, color: '#303133', whiteSpace: 'nowrap' }}>抽佣出账日</Text>
                {billDay ? (
                    <span style={{ fontSize: 14, color: '#606266' }}>
                        每月 <strong style={{ fontSize: 22, fontWeight: 700, color: '#409eff', margin: '0 2px', verticalAlign: -2 }}>{billDay}</strong> 号
                    </span>
                ) : <span style={{ fontSize: 14, color: '#c0c4cc' }}>暂无配置</span>}
                <Text type="secondary" style={{ fontSize: 12, color: '#b0b3bb', flex: 1 }}>与《抽佣账单》共用出账日，系统在次月该日自动生成上月广告抽佣账单</Text>
                <Button type="link" onClick={() => { setBillDayEditVal(billDay); setBillDayEditVisible(true); }}>修改</Button>
            </div>

            <Modal
                title="修改抽佣出账日"
                open={billDayEditVisible}
                onOk={() => { setBillDay(billDayEditVal); message.success('出账日设置成功'); setBillDayEditVisible(false); }}
                onCancel={() => setBillDayEditVisible(false)}
                okText="保存" cancelText="取消" destroyOnClose width={420}
            >
                <div style={{ fontSize: 13, color: '#909399', padding: '12px 16px', background: '#f7f8fa', borderRadius: 6, lineHeight: 1.6, marginBottom: 16 }}>
                    系统将在次月该日自动生成上月广告抽佣账单，与订单抽佣账单共用此出账日，修改后立即生效。
                </div>
                <Select value={billDayEditVal} onChange={setBillDayEditVal} style={{ width: '100%' }} size="large"
                    options={Array.from({ length: 28 }, (_, i) => ({ label: `每月 ${i + 1} 号`, value: i + 1 }))} />
            </Modal>

            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
                title={<Title level={4} style={{ margin: 0 }}>广告抽佣账单审核</Title>}
                extra={<Button icon={<DownloadOutlined />} onClick={() => message.success('导出任务已生成（原型演示）')}>导出</Button>}
            >
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={[
                        {
                            key: 'billed',
                            label: `系统已出账 (${billedData.length})`,
                            children: (
                                <>
                                    <Form layout="inline" style={{ marginBottom: 16 }}>
                                        <Form.Item><Input placeholder="账单编号" style={{ width: 170 }} /></Form.Item>
                                        <Form.Item><Input placeholder="企业名称" style={{ width: 200 }} /></Form.Item>
                                        <Form.Item>
                                            <Select placeholder="广告源" style={{ width: 130 }} allowClear>
                                                <Select.Option value={1}>企业广告源</Select.Option>
                                                <Select.Option value={2}>平台广告源</Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item>
                                            <Select placeholder="账单状态" style={{ width: 120 }} allowClear>
                                                <Select.Option value={2}>待确认</Select.Option>
                                                <Select.Option value={3}>已确认</Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item><Input placeholder="账单周期（YYYY-MM）" style={{ width: 160 }} /></Form.Item>
                                        <Form.Item>
                                            <Space>
                                                <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                                                <Button icon={<ReloadOutlined />}>重置</Button>
                                            </Space>
                                        </Form.Item>
                                    </Form>
                                    <Table columns={billedColumns} dataSource={billedData} rowKey="id"
                                        scroll={{ x: 1900 }}
                                        pagination={{ showSizeChanger: true, showTotal: (total) => `共 ${total} 条记录` }} />
                                </>
                            ),
                        },
                        {
                            key: 'unbilled',
                            label: `系统未出账 (${unbilledData.length})`,
                            children: (
                                <>
                                    <Form layout="inline" style={{ marginBottom: 16 }}>
                                        <Form.Item><Input placeholder="企业名称" style={{ width: 200 }} /></Form.Item>
                                        <Form.Item>
                                            <Select placeholder="广告源" style={{ width: 130 }} allowClear>
                                                <Select.Option value={1}>企业广告源</Select.Option>
                                                <Select.Option value={2}>平台广告源</Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item>
                                            <Space>
                                                <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                                                <Button icon={<ReloadOutlined />}>重置</Button>
                                            </Space>
                                        </Form.Item>
                                    </Form>
                                    <Table columns={unbilledColumns} dataSource={unbilledData} rowKey="id"
                                        scroll={{ x: 900 }}
                                        pagination={{ showSizeChanger: true, showTotal: (total) => `共 ${total} 条记录` }} />
                                </>
                            ),
                        },
                    ]}
                />
            </Card>

            {/* 账单详情抽屉 */}
            <Drawer
                title={<Space><FileTextOutlined style={{ color: '#1890ff' }} /><span>广告抽佣账单详情</span></Space>}
                width="75%"
                onClose={() => { setDetailVisible(false); setCurrentBillId(null); }}
                open={detailVisible}
                destroyOnClose
                extra={detail && detail.status === 2 && (
                    <Button type="primary" onClick={() => { setConfirmRow(detail); setConfirmAction(1); setConfirmReason(''); setConfirmVisible(true); }}>立即确认</Button>
                )}
            >
                {detail ? (
                    <>
                        <Descriptions bordered column={3} size="small" style={{ marginBottom: 20 }}>
                            <Descriptions.Item label="账单编号">{detail.serialNumber}</Descriptions.Item>
                            <Descriptions.Item label="账单周期">{detail.date}</Descriptions.Item>
                            <Descriptions.Item label="状态">
                                <span style={{ color: statusColor[detail.status] }}>● {statusLabel[detail.status] || '-'}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label="企业名称">{detail.companyName}</Descriptions.Item>
                            <Descriptions.Item label="广告源">
                                <Tag color={adSourceColor[detail.adSource]}>{adSourceLabel[detail.adSource] || '-'}</Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="结算账户">
                                <Tag color={accountColor[detail.adSource]}>{accountLabel[detail.adSource] || '-'}</Tag>
                            </Descriptions.Item>
                            {detail.status === 3 && (
                                <Descriptions.Item label="确认出账时间">{detail.ackBillTime || '-'}</Descriptions.Item>
                            )}
                            <Descriptions.Item label="系统出账时间">{detail.billTime || '-'}</Descriptions.Item>
                        </Descriptions>

                        {renderSummaryCards(detail)}

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                            <Title level={5} style={{ margin: 0, fontWeight: 600 }}>账单明细</Title>
                            <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('导出任务已生成（原型演示）')}>导出</Button>
                        </div>
                        <Table columns={detailColumns} dataSource={detail.details || []} rowKey="key" size="small"
                            scroll={{ x: 'max-content' }} pagination={false} />
                    </>
                ) : <Empty description="暂无数据" />}
            </Drawer>

            {/* 确认出账弹窗 */}
            <Modal
                title="确认出账"
                open={confirmVisible}
                onOk={handleConfirmSubmit}
                onCancel={() => setConfirmVisible(false)}
                okText={confirmAction === 2 ? '确认重出' : '确认出账'} cancelText="取消" destroyOnClose width={560}
            >
                {confirmRow && (
                    <div style={{ padding: '8px 0' }}>
                        <Alert
                            message={confirmRow.adSource === 2 ? '本期结算为《企业收益账户》余额增加！' : '本期结算为《企业消费账户》余额支出！'}
                            type="success" showIcon style={{ marginBottom: 16 }} />
                        <Descriptions bordered column={2} size="small" style={{ marginBottom: 16 }}>
                            <Descriptions.Item label="账单编号" span={2}>{confirmRow.serialNumber}</Descriptions.Item>
                            <Descriptions.Item label="企业">{confirmRow.companyName}</Descriptions.Item>
                            <Descriptions.Item label="账单周期">{confirmRow.date}</Descriptions.Item>
                            <Descriptions.Item label="广告源">
                                <Tag color={adSourceColor[confirmRow.adSource]}>{adSourceLabel[confirmRow.adSource]}</Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="抽佣总额">¥ {fmtYuan(confirmRow.commissionCny)} / $ {fmtYuan(confirmRow.commissionUsd)}</Descriptions.Item>
                        </Descriptions>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>确认操作</div>
                        <Select value={confirmAction} onChange={setConfirmAction} style={{ width: '100%' }}>
                            <Select.Option value={1}><Space><CheckCircleOutlined style={{ color: '#52c41a' }} />确认出账</Space></Select.Option>
                            <Select.Option value={2}><Space><ReloadOutlined style={{ color: '#e6a23c' }} />重新出账</Space></Select.Option>
                        </Select>
                        {confirmAction === 2 && (
                            <>
                                <div style={{ margin: '12px 0 8px', fontWeight: 500 }}>重新出账原因</div>
                                <Input.TextArea value={confirmReason} onChange={(e) => setConfirmReason(e.target.value)}
                                    rows={4} maxLength={200} showCount placeholder="请输入重新出账原因" />
                            </>
                        )}
                    </div>
                )}
            </Modal>

            {/* 操作记录弹窗 */}
            <Modal
                title="操作记录"
                open={logsVisible}
                onCancel={() => setLogsVisible(false)}
                footer={null}
                width={800}
                destroyOnClose
            >
                {logsRow ? (
                    <div style={{ padding: '8px 0' }}>
                        <Alert
                            message={logsRow.adSource === 2 ? '本期结算为《企业收益账户》余额增加！' : '本期结算为《企业消费账户》余额支出！'}
                            type="success" showIcon style={{ marginBottom: 20 }} />
                        {logSteps(logsRow).map((step, idx) => (
                            <div key={idx} style={{ position: 'relative', paddingLeft: 20, marginBottom: idx < logSteps(logsRow).length - 1 ? 24 : 0 }}>
                                {idx < logSteps(logsRow).length - 1 && (
                                    <div style={{ position: 'absolute', left: 5, top: 14, bottom: -24, width: 1, background: '#dcdfe6' }} />
                                )}
                                <span style={{
                                    display: 'inline-block', width: 10, height: 10, borderRadius: '50%',
                                    background: step.color, verticalAlign: 'middle', position: 'relative', left: -20, marginRight: -12,
                                }} />
                                <div style={{ marginBottom: 12, lineHeight: '20px' }}>
                                    <span style={{ fontWeight: 600, color: step.color }}>{step.title}</span>
                                    <Text type="secondary" style={{ fontSize: 12, marginLeft: 12 }}>{step.time}</Text>
                                </div>
                                <div style={{ paddingLeft: 4 }}>{step.render()}</div>
                            </div>
                        ))}
                    </div>
                ) : <Empty description="暂无操作记录" />}
            </Modal>
        </div>
    );
};

export default AdCommissionBill;
